import { useCallback, useState } from 'react'
import { Link, useHistory, useParams } from 'react-router-dom'
import {
  getClassroomRequest,
  getStudentsRequest,
  getChildrenRequest,
} from 'src/services/api.service'
import { useAuth } from 'src/contexts/auth.context'
import { useNotification } from 'src/contexts/notification.context'
import { BackLink } from 'src/components/common'
import Table from 'src/components/table/table'

// import InviteModal from './modals/invite'
import { isClass } from 'src/tools'
import { routes } from 'src/navigation/routes'
import StudentRow from './components/student-row'

export const ClassroomStudents = () => {
  const { user, state } = useAuth()
  const history = useHistory()
  const { showErrorHelper } = useNotification()
  const { id } = useParams()

  const [classroom, setClassroom] = useState([])
  const [items, setItems] = useState([])
  const [loading, setLoading] = useState(false)
  const [count, setCount] = useState(0)
  const [pageCount, setPageCount] = useState(0)
  const [filter, setFilter] = useState({
    subject_id: null,
    grade_id: null,
    status: null,
  })
  const [isShowStudentsModal, setIsShowStudentsModal] = useState(false)
  const [selClassroom, setSelClassroom] = useState(null)

  const fetchData = useCallback(async ({ pageSize, pageIndex, filterData }) => {
    try {
      setLoading(true)
      let response = await getClassroomRequest(id)
      setClassroom(response.data.item)

      response = await getStudentsRequest({
        ...filterData,
        classroom_id: id,
        page: pageIndex + 1,
        perPage: pageSize,
      })
      setItems(response.data.items)
      setCount(response.data.total)
      setPageCount(Math.ceil(response.data.total / pageSize))
    } catch (error) {
      showErrorHelper(error)
    }
    setLoading(false)
  }, [])

  const handleInviteClick = (item) => () => {
    setSelClassroom(item)
    setIsShowStudentsModal(true)
  }

  // const handleCloseStudentsModal = () => {
  //   setIsShowStudentsModal(false);
  // }

  // const handleSubmitInviteStudent = async (values) => {
  //   try {
  //     await sendInviteRequest(values)
  //     setIsShowStudentsModal(false);
  //   } catch (error) {
  //     showErrorHelper(error);
  //   }
  // }

  const handleAddStudent = (e) => {
    e.preventDefault()
  }

  return (
    <>
      <div className="sectionHb-top">
        <BackLink to={routes.classrooms.index} />
        <h2 className="sectionHb-title">{classroom && classroom.name}</h2>
      </div>

      <div className="sectionHb-block purchaseHb">
        <div className="sectionHb-block__wrap">
          <div className="row">
            <div className="col-lg-9 col-md-6 col-sm-6">
              <div className="searchHb searchHb-middle">
                <div className="input-block ">
                  <i className="hb-ico search-ico" />
                  <input type="text" name="search" placeholder="Search" />
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="input-block">
                <a
                  onClick={handleAddStudent}
                  className="primary-btn primary-btn__big"
                >
                  +&nbsp; Student
                </a>
              </div>
            </div>
          </div>

          <div className="details-table details-table__second">
            <div className="details-table__row details-table__top">
              <div className="details-table__col details-table__col-1" />
              <div className="details-table__col details-table__col-2">
                Student name
              </div>
              <div className="details-table__col details-table__col-3">
                Practices
              </div>
              <div className="details-table__col details-table__col-4">
                Test
              </div>
              <div className="details-table__col details-table__col-5">
                Score
              </div>
              <div className="details-table__col details-table__col-6">
                Progress
              </div>
              <div className="details-table__col details-table__col-7">
                Help
              </div>
            </div>

            <Table
              data={items}
              fetchData={fetchData}
              pageCount={pageCount}
              filter={filter}
              loading={loading}
              rowComponent={(item) => (
                <StudentRow
                  item={item}
                  onInviteClick={handleInviteClick(item)}
                  onStudentClick={handleInviteClick(item)}
                />
              )}
            />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
          </div>
        </div>
      </div>

      {/* <!-- Modals --> */}
      <div
        className={`mask__modal ${isClass(isShowStudentsModal, 'active')}`}
      />

      {/* <InviteModal
        active={isShowStudentsModal}
        item={selClassroom}
        onClose={handleCloseStudentsModal}
        onSubmit={handleSubmitInviteStudent}
      /> */}
    </>
  )
}
